import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import css from './DeepLinkModal.css';
import Footer from '../common/Footer';
import StyledButton from '../common/StyledButton';
import Icon from 'SF/MaterialIcon';
import Header from './Header';
import DeepLinkTabs from './DeepLinkTabs';
import { isValidUrl } from 'utils/text';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { isEmpty } from 'lodash';

const DeepLinkModal = props => {
  Modal.setAppElement(document.getElementById('main-center'));
  const [externalURL, setExternalURL] = useState("http://");
  const [internalLink, setInternalLink] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);

  const isExternalURLValid = isValidUrl(externalURL.trim());
  const isInternalLinkValid = !isEmpty(internalLink.url);

  const isFinishButtonDisabled = (
    (selectedIndex === 0 && !isExternalURLValid) || 
    (selectedIndex === 1 && (props.externalLinksOnly || !isInternalLinkValid))
  );

  const onFinishClick = () => {
    if ( isFinishButtonDisabled ) return; // Does nothing
    if ( selectedIndex === 0 ) {
      // Check if URI is encoded to avoid encoding it twice
      const isEncoded = externalURL !== decodeURI(externalURL);
      props.confirmLink(sanitizeUrl(isEncoded ? externalURL : encodeURI(externalURL)));
    } else {
      props.confirmLink(internalLink);
    }
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.closeModal}
      overlayClassName={css['overlay']}
      className={css['modal']}
      shouldCloseOnOverlayClick={false}>
      <div className={css['container']}>
        <div className={css['content']}>
          <Header closeModal={props.closeModal} />
          <DeepLinkTabs
            selectedIndex={selectedIndex} 
            setSelectedIndex={setSelectedIndex}
            externalURL={externalURL}
            setExternalURL={setExternalURL}
            setInternalLink={setInternalLink}
            isExternalURLValid={isExternalURLValid}
            isInternalLinkValid={isInternalLinkValid}
            onSubmit={onFinishClick}
            externalLinksOnly={props.externalLinksOnly}
            messageTemplateType={props.messageTemplateType}
            hasSSOMethod={props.hasSSOMethod}
          />
        </div>
        <Footer 
          primaryButton={(
            <StyledButton
              dataRole="deeplinkFinishButton"
              aria-disabled={isFinishButtonDisabled}
              onClick={onFinishClick}>
              Finish
            </StyledButton>
          )}
          secondaryButton={(
            <StyledButton 
              dataRole="deeplinkBackButton"
              asLink 
              onClick={props.closeModal}>
              <span><Icon icon='arrow_back' aria-hidden='true'/>Back</span>
            </StyledButton>
          )}
        />
      </div>
    </Modal>
  );
}

DeepLinkModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmLink: PropTypes.func.isRequired,
  externalLinksOnly: PropTypes.bool.isRequired,
  messageTemplateType: PropTypes.string,
  hasSSOMethod: PropTypes.bool.isRequired,
};

export default DeepLinkModal;
